import { render } from "./WaitingRoom.vue?vue&type=template&id=9a5818f8&ts=true"
import script from "./WaitingRoom.vue?vue&type=script&lang=ts"
export * from "./WaitingRoom.vue?vue&type=script&lang=ts"

import "./WaitingRoom.vue?vue&type=style&index=0&id=9a5818f8&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__